<template>
    <router-view />
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
    computed: {
        ...mapGetters('base', {
            selectedProduct: 'selectedProduct',
        }),
    },
    methods: {
        ...mapActions('dashboards', {
            updateBaseData: 'updateBaseData',
        }),
    },
    created() {
        this.updateBaseData({
            selectedProduct: { ...this.selectedProduct },
        });
    },
    watch: {
        selectedProduct(newValue) {
            this.updateBaseData({
                selectedProduct: { ...newValue },
            });
        },
    },
};
</script>